import { IContentBlock } from "@colibrio/colibrio-reader-framework/colibrio-readingsystem-base";
import { TextAtom } from "src/lib/cheshire-cat/models/text-atom.model";
import { ContentBlock } from "./epub-text-iterator";
import { ContentBlockData } from "./text-processor";

export class TextProcessorWorkerWrapper {
    private worker: Worker;
    private id = 0;
    private messages = new Map<number, {
        contentBlocks: IContentBlock[],
        resolve: (r: any) => void;
        reject: (e: unknown) => void;
    }>();

    constructor() {
        this.worker = new Worker(new URL('../epub-utils/text-processor.worker.ts', import.meta.url), { type: 'module' });
        this.worker.onmessage = (event) => {
            const { id, processedBlocksData } = event.data;
            const message = this.messages.get(id);
            if (message) {
                // NOTE 2 FEB 2026
                // revert the IContentBlockData back to a IContentBlock
                const processedBlocks: ContentBlock[] = processedBlocksData.map((data: ContentBlockData) => ({
                    contentBlock: message.contentBlocks.find((x => x.getId() === data.contentBlock.id)),
                    textMapItems: data.textMapItems
                }));
                message.resolve(processedBlocks);
            } else {
                console.warn(`No resolve found for message id: ${id} (${event.data})`);
            }
        };
    }

    async postMessage(contentBlocks: IContentBlock[], textMap: TextAtom[]): Promise<any> {
        return new Promise((resolve, reject) => {
            this.id++;
            this.messages.set(this.id, {
                contentBlocks: this.flattenBlocks(contentBlocks), 
                resolve, 
                reject
            });
            // NOTE 2 FEB 2026
            // need to convert the IContentBlock to something serializable to send to worker
            // there is something in the IContentBlock that throws an error otherwise
            this.worker.postMessage({
                id: this.id,
                contentBlocks: contentBlocks.map((x) => x.toSerializableData()),
                textMap
            });
        });
    }

    terminate(): void {
        this.worker.terminate();
    }

    private flattenBlocks(blocks: IContentBlock[]): IContentBlock[] {
        return blocks.flatMap(block => [
            block,
            ...this.flattenBlocks(block.getChildren() ?? [])
        ]);
    }
}